 import { format } from "date-fns";
 import { useAdminPartnerCodeRedemptions } from "@/hooks/useAdminPartnerCodeRedemptions";
 import { Loader2, User, Calendar, CreditCard, Ticket } from "lucide-react";
 import { Badge } from "@/components/ui/badge";
 
 interface PartnerCodeRedemptionsListProps {
   partnerCodeId: string;
 }
 
 export const PartnerCodeRedemptionsList = ({ partnerCodeId }: PartnerCodeRedemptionsListProps) => {
   const { redemptions, isLoading } = useAdminPartnerCodeRedemptions(partnerCodeId);
 
   if (isLoading) {
     return (
       <div className="flex items-center justify-center py-4">
         <Loader2 className="h-4 w-4 animate-spin text-muted-foreground" />
       </div>
     );
   }
 
   if (redemptions.length === 0) {
     return (
       <div className="py-4 text-center text-sm text-muted-foreground">
         No redemptions yet
       </div>
     );
   }
 
   return (
     <div className="space-y-2">
       <div className="text-xs font-medium text-muted-foreground px-2">
         {redemptions.length} redemption{redemptions.length !== 1 ? "s" : ""}
       </div>
       <div className="divide-y divide-border rounded-md border bg-muted/30">
         {redemptions.map((redemption) => (
           <div key={redemption.id} className="flex items-center justify-between px-3 py-2 text-sm">
             <div className="flex items-center gap-3">
               <div className="flex flex-col">
                 <div className="flex items-center gap-1.5">
                   <User className="h-3 w-3 text-muted-foreground" />
                   <span className="font-medium">{redemption.userName}</span>
                 </div>
                 <span className="text-xs text-muted-foreground">{redemption.userEmail}</span>
               </div>
             </div>
             <div className="flex items-center gap-4 text-xs">
               <div className="flex items-center gap-1 text-muted-foreground">
                 <CreditCard className="h-3 w-3" />
                 <span>{redemption.creditsGranted} credits</span>
               </div>
               <div className="flex items-center gap-1">
                 <Ticket className="h-3 w-3 text-muted-foreground" />
                 <Badge variant="outline" className="h-5 px-1.5 text-xs">
                   {redemption.eventsBooked} events
                 </Badge>
               </div>
               <div className="flex items-center gap-1 text-muted-foreground">
                 <Calendar className="h-3 w-3" />
                 <span>
                   {redemption.redeemedAt
                     ? format(new Date(redemption.redeemedAt), "MMM d, yyyy")
                     : "Unknown"}
                 </span>
               </div>
             </div>
           </div>
         ))}
       </div>
     </div>
   );
 };